import LeftPane from './LeftPane'

import './style.scss'

export { LeftPane }
export default LeftPane
